import {
  MULTIMEDIA_TYPES,
  AddMultimediaAction,
  GetAllMultimediaAction,
  GetAllMultimediaSuccessAction,
  GetOneMultimediaAction,
  GetOneMultimediaSuccessAction,
  SetApiMultimediaRequestStateAction,
  SetApiMultimediaRequestErrorAction,
  ResetMultimediaAction,
  SetApiAllMultimediaRequestStateAction,
  SetApiAllMultimediaRequestErrorAction,
  EditMultimediaAction,
  DeleteMultimediaAction,
} from './multimediaTypes';
import {
  MultimediaFilterValues,
  MultimediaGetResponse,
  MultimediaParams,
  MultimediaValues,
} from '../model/multimediaModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export const setApiMultimediaRequestState = (
  apiMultimediaRequestState: API_REQUEST_STATE,
): SetApiMultimediaRequestStateAction => ({
  type: MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_STATE,
  payload: {
    apiMultimediaRequestState: apiMultimediaRequestState,
  },
});

export const setApiMultimediaRequestError = (
  apiMultimediaRequestError: string,
): SetApiMultimediaRequestErrorAction => ({
  type: MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_ERROR,
  payload: {
    apiMultimediaRequestError: apiMultimediaRequestError,
  },
});

export const setApiAllMultimediaRequestState = (
  apiAllMultimediaRequestState: API_REQUEST_STATE,
): SetApiAllMultimediaRequestStateAction => ({
  type: MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_STATE,
  payload: {
    apiAllMultimediaRequestState: apiAllMultimediaRequestState,
  },
});

export const setApiAllMultimediaRequestError = (
  apiCategoriesRequestError: string,
): SetApiAllMultimediaRequestErrorAction => ({
  type: MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_ERROR,
  payload: {
    apiAllMultimediaRequestError: apiCategoriesRequestError,
  },
});

export const addMultimedia = (multimedia: MultimediaValues): AddMultimediaAction => ({
  type: MULTIMEDIA_TYPES.ADD,
  payload: {
    multimedia: multimedia,
  },
});

export const resetMultimedia = (): ResetMultimediaAction => ({
  type: MULTIMEDIA_TYPES.RESET,
  payload: null,
});

export const getAllMultimedia = (multimediaFilter: MultimediaFilterValues): GetAllMultimediaAction => ({
  type: MULTIMEDIA_TYPES.GET_ALL,
  payload: {
    multimediaFilter: multimediaFilter,
  },
});

export const getAllMultimediaSuccess = (multimedia: MultimediaGetResponse[]): GetAllMultimediaSuccessAction => ({
  type: MULTIMEDIA_TYPES.GET_ALL_SUCCESS,
  payload: {
    multimedia: multimedia,
  },
});

export const getMultimedia = (params: MultimediaParams): GetOneMultimediaAction => ({
  type: MULTIMEDIA_TYPES.GET_ONE,
  payload: {
    params: {
      id: params.id,
    },
  },
});

export const getOneMultimediaSuccess = (multimedia: MultimediaGetResponse): GetOneMultimediaSuccessAction => ({
  type: MULTIMEDIA_TYPES.GET_ONE_SUCCESS,
  payload: {
    multimedia: multimedia,
  },
});

export const editMultimedia = (params: MultimediaParams, multimedia: MultimediaValues): EditMultimediaAction => ({
  type: MULTIMEDIA_TYPES.EDIT,
  payload: {
    multimedia: multimedia,
    params: {
      id: params.id,
    },
  },
});

export const deleteMultimedia = (params: MultimediaParams): DeleteMultimediaAction => ({
  type: MULTIMEDIA_TYPES.DELETE,
  payload: {
    params: {
      id: params.id,
    },
  },
});
